export default __webpack_public_path__ + "static/ResearchUI-fd6c107a396d3d361a9a8f394477df37.png";